import React, { ReactElement, useState } from 'react';
import { SearchResults, SingleSelect } from 'idsk-react-components';
import { ExpansionPanel, useResponsiveContext } from 'slovlex-idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import CiselnikPolozka from '../../../model/CiselnikPolozka';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import {
  MAX_MULTISELECT_RESULT, SHOW_ALL_MAX_RESULT,
} from '../../../constants/MultiSelectConstant';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import useSearchValidPolozkyCiselnik from '../hooks/useSearchValidPolozkyCiselnik';

interface Props {
  onUpdateField: SafeParameterSetter<NavrhAktuEuFilter>;
  onUpdateFieldCopy: SafeParameterSetter<NavrhAktuEuFilter>;
  filter: NavrhAktuEuFilter;
  filterCopy: NavrhAktuEuFilter;
}

const InstituciaSingleSelect = ({
  onUpdateField,
  onUpdateFieldCopy,
  filter,
  filterCopy,
}: Props): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [showList, setShowList] = useState<boolean>(false);
  const [limit, setLimit] = useState(MAX_MULTISELECT_RESULT);
  const { isSmallScreen } = useResponsiveContext();

  const {
    polozkyCiselnik: instituciaList,
    polozkyCiselnikStatus: instituciaListStatus,
  } = useSearchValidPolozkyCiselnik(
    {
      kody: [],
      typy: [TypCiselnikaEnum.Institucia],
      ids: [],
      platny: true,
      hladanyNazov: filterCopy?.institucia?.nazov || searchText,
      limit,
    },
  );

  const handleSelectedItemChange = (item: CiselnikPolozka): void => {
    setShowList(false);
    if (item) {
      onUpdateField('institucia', item);
    }
    onUpdateFieldCopy('institucia', item);
  };

  return (
    <ExpansionPanel title="Inštitúcia" isExpanded={!!filter.institucia && !isSmallScreen}>
      <div className="slovlex-idsk-side-panel-input-wrapper single-select-input-wrapper">
        <SingleSelect
          id="instituciaSingleSelect"
          name="instituciaSingleSelect"
          searchText={searchText || ''}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          selectedItem={filterCopy.institucia || null}
          setSelectedItem={handleSelectedItemChange}
          selectedItemValue={filter.institucia?.nazov || ''}
          visibilityMinSearchLength={0}
          showList={showList}
          setShowList={setShowList}
        />
        <SearchResults
          loadingShowAll={instituciaListStatus.loading}
          className="single-select-fazet"
          handleShowAll={() => {
            setLimit(SHOW_ALL_MAX_RESULT);
          }}
          withShowAllButton={(limit === MAX_MULTISELECT_RESULT
              && instituciaList.length === MAX_MULTISELECT_RESULT)
            || (limit === SHOW_ALL_MAX_RESULT && instituciaList.length <= MAX_MULTISELECT_RESULT)}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          data={instituciaList}
          setSelectedItem={handleSelectedItemChange}
          dataAttributesToShow={[{ key: 'nazov', label: '' }]}
          type="column"
          size="m"
          visible={searchText.trim().length > 0 || showList}
        />
      </div>
    </ExpansionPanel>
  );
};

export default InstituciaSingleSelect;
